<template>
  <div>
    <!-- 筛选条件 工具栏-->
    <div class="filter-container">
      <!-- <div class="label filter-item" style="margin-right:5px;">筛选条件：</div> -->
      <div style="width: 100%;display: flex;justify-content: space-between;">
        <div style="display: flex;flex-flow: row wrap;">
          <!-- 搜索 -->
          <div class="filter-data">
            <el-input class="filter-item" size="small" v-model="search" placeholder="模糊查找任务名称" clearable style="width:200px" @keyup.enter.native="handleFile" @input="handleFilter">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>

          <!-- 项目选择-->
          <div class="filter-data">
            <div class="label filter-item">项目：</div>
            <el-select class="filter-item" size="small" v-model="projectIds" multiple collapse-tags filterable clearable placeholder="请选择" style="width:220px" @change="handleFilter">
              <el-option v-for="(item,index) in projectOptions" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>

          <!-- 设计师-->
          <div class="filter-data" v-if="source != 'userCreate'">
            <div class="label filter-item">设计师：</div>
            <el-select class="filter-item" size="small" v-model="designerIds" multiple collapse-tags filterable clearable placeholder="请选择" style="width:180px" @change="handleFilter">
              <el-option v-for="(item,index) in designerOptions" :key="index" :label="item.realname" :value="item.id"></el-option>
            </el-select>
          </div>

          <!-- 用途 -->
          <div class="filter-data" style="margin-right: 15px" v-if="source != 'myCreate'">
            <div class="label filter-item">用途：</div>

            <multiple-cascader class="filter-item" v-model="putValueList" :optionsList="useOptions" placeholder="请选择" size="small" style="width:180px" clearable collapse-tags filterable
              :props="{ multiple: true,expandTrigger: 'hover',label:'label',value:'value',children:'children' }" key="用途" popper-class="cascader-box-yt" @change="handleFilterUse"></multiple-cascader>
          </div>

          <!-- 完成时间-->
          <div class="filter-data">
            <div class="label filter-item">完成时间：</div>
            <el-date-picker size="small" class="filter-item" v-model="finishTimes" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="center" unlink-panels range-separator="~" start-placeholder="开始日期"
              end-placeholder="结束日期" style="width:230px" @change="handleFilter"></el-date-picker>
          </div>

          <!-- 任务状态 -->
          <div class="filter-data" v-if="source=='userCreate' || source=='myCreate'">
            <div class="label filter-item">任务状态：</div>
            <el-select class="filter-item" size="small" v-model="status" filterable clearable placeholder="请选择" style="width:220px" @change="handleFilter">
              <el-option v-for="(item,index) in statusOptions" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>

          <el-button class="filter-item" size="mini" style="margin-right:10px; height:32px" @click="isShow = !isShow">
            更多筛选
            <i class="el-icon--right" :class="isShow? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
          </el-button>
        </div>
        <div style="display: flex;flex-flow: row wrap;">
          <el-button class="filter-item" size="mini" v-if="accessPoint['artflow:export']" style="margin-right:10px; height:32px" @click="handleDownload">
            <svg-icon icon-class="download_shape" style="font-size:14px;margin-right:6px" />下载
          </el-button>
        </div>
      </div>
    </div>

    <div class="filter-container" v-if="isShow" style="margin-top:-8px">
      <!-- 按钮组 -->
      <!-- <div class="filter-data" style="margin-right: 15px">
                <template v-for="(item,index) in putButns">
                    <el-button class="filter-item" size="small" :key="index" :type="putValue == item.id ? 'primary' : ''" @click="handlePut(item.id)">{{item.name}}</el-button>
                </template>
            </div> -->

      <!-- 紧急度选择-->
      <!-- <div class="filter-data">
                <div class="label filter-item">紧急度：</div>
                <el-select class="filter-item" size="small" v-model="priority" filterable clearable placeholder="请选择" style="width:130px" @change="handleFilter">
                    <el-option v-for="(item,index) in priorityOptions" :key="index" :label="item" :value="item"></el-option>
                </el-select>
            </div> -->

      <!-- 用途 -->
      <div class="filter-data" style="margin-right: 15px" v-if="source == 'myCreate'">
        <div class="label filter-item">用途：</div>
        <multiple-cascader class="filter-item" v-model="putValueList" :optionsList="useOptions" placeholder="请选择" size="small" style="width:180px" clearable collapse-tags filterable
              :props="{ multiple: true,expandTrigger: 'hover',label:'label',value:'value',children:'children' }" key="用途" popper-class="cascader-box-yt" @change="handleFilterUse"></multiple-cascader>
      </div>

      <!-- 创建时间-->
      <div class="filter-data">
        <div class="label filter-item">创建时间：</div>
        <el-date-picker size="small" class="filter-item" v-model="createTimes" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="center" unlink-panels range-separator="~" start-placeholder="开始日期"
          end-placeholder="结束日期" :picker-options="pickerOptions" style="width:230px" @change="handleFilter"></el-date-picker>
      </div>

      <div class="filter-data">
        <div class="label filter-item">共享资源库：</div>
        <el-select class="filter-item" size="small" v-model="share" filterable clearable placeholder="请选择" style="width:130px" @change="handleFilter">
          <el-option v-for="(item,index) in shareOptions" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>

      <div class="filter-data">
        <div class="label filter-item">任务分类：</div>
        <el-select class="filter-item" size="small" v-model="taskTypeIds" collapse-tags multiple filterable clearable placeholder="请选择" style="width:200px" @change="handleFilter">
          <el-option v-for="(item,index) in taskTypeOptions" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>

    </div>
  </div>
</template>

<script>
import MultipleCascader from '@Sys~/components/MultipleCascader'
import { parseTime } from '@/utils'
import { projectList_ajax, designerListByRoleIds_ajax, taskListTree_ajax, taskTypeList_ajax } from '@File~/api/file'
export default {
  components: { MultipleCascader },
  name: 'ToolbarTask',
  props: {
    source: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false,
      search: '',
      accessPoint: this.$store.getters.accessPoint, //权限点
      // putValue:'',
      // putButns:[
      //     {
      //         id: 29,
      //         name: '投放资源-平面'
      //     },
      //     {
      //         id: 41,
      //         name: '投放资源-视频'
      //     },
      // ],
      // 用途
      putValueList: [],
      putValue: [],
      useOptions: [],
      // 任务分类：
      taskTypeIds: [],
      taskTypeOptions: [],

      // 时间范围 快捷键
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit('pick', [start, end]);
            }
          },

          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去14天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }
        ],
        // 当前日期之前的日期不可选
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      // 紧急度
      priority: '',
      priorityOptions: ['P1', 'P2', 'P3'],
      // 状态
      status: '',
      statusOptions: [{ id: 0, name: '待分配' }, { id: 1, name: '待确认' }, { id: 2, name: '进行中' }, { id: 3, name: '已完成' }, { id: -1, name: '已拒绝' }],
      // 项目
      projectIds: [],
      projectOptions: [],
      // 设计师
      designerIds: [],
      designerOptions: [],

      // 创建时间
      createTimes: [],
      //完成时间
      finishTimes: [],

      // 是否显示
      share: '',
      shareOptions: [{ id: 1, name: '是' }, { id: 0, name: '否' }]
    }
  },

  created() {
    this.getProject() // 项目列表
    this.getUseList() // 用途列表
    this.getDesigner() // 设计师列表接口
    this.getTaskType()
  },

  methods: {
    // 项目列表
    getProject() {
      projectList_ajax().then(response => {
        if (response.code == 1) {
          this.projectOptions = response.data
        }
      })
    },

    // 设计师列表接口
    getDesigner() {
      const roleIds = this.$store.getters.roles.toString()
      designerListByRoleIds_ajax(roleIds).then(response => {
        if (response.code == 1) {
          this.designerOptions = response.data
        }
      })
    },

    // 获取用途列表
    getUseList() {
      taskListTree_ajax().then(response => {
        if (response.code == 1) {
          this.useOptions = this.getUseOptions(response.data)
        }
      })
    },
    getUseOptions(list) {
      list.forEach(item => {
        item.label = item.name
        item.value = item.id
        item.children = item.child
        if (item.child && item.child.length > 0) {
          this.getUseOptions(item.child)
        }
      })
      return list
    },

    // 项目分类
    getTaskType() {
      taskTypeList_ajax({ taskIds: this.putValue }).then(response => {
        if (response.code == 1) {
          this.taskTypeOptions = response.data
        }
      })
    },

    // 监听投放按钮
    // handlePut(val) {
    //     // console.log(val)
    //     if(this.putValue && this.putValue == val) {
    //         this.putValue = ''
    //     } else {
    //         this.putValue = val
    //     }
    //     this.$emit('filter')
    // },

    // 用途变化
    handleFilterUse(val) {
      this.putValue = [];
      val.forEach(item => {
        this.putValue.push(item[1])
      })
      this.taskTypeIds = [];
      this.getTaskType()
      this.handleFilter()
    },
    // 查询
    handleFilter() {
      this.$emit('filter')
    },

    // 下载
    handleDownload() {
      this.$emit('download')
    }

  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  margin: 5px 0 0;
  //padding: 10px 10px 0px 20px;
  //background: #ffffff;
  // box-shadow: 0 0 2px inset rgba(0,0,0,.28);
  //border-radius: 5px;
  .filter-data {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
  }
  .label {
    font-size: 15px;
    margin-right: 3px;
    color: #7b7b7b;
  }
}

.border-card {
  .list {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: flex-start;
    border-bottom: 1px dashed #ccc;
    margin-bottom: 5px;
    padding-bottom: 5px;

    ::v-deep .el-radio-button__inner {
      border: 0;
    }
    ::v-deep .el-radio-button:first-child .el-radio-button__inner,
    ::v-deep .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0;
    }
    ::v-deep .el-checkbox {
      line-height: 26px;
    }
    .title {
      margin-right: 20px;
      width: 84px;
      line-height: 26px;
      font-size: 14px;
      font-weight: normal;
      color: #aeaeae;
      text-align: right;
    }
    .butn-box {
      width: 130px;
      ::v-deep .el-button--mini {
        padding: 4px 8px;
      }
      ::v-deep .el-button + .el-button {
        margin-left: 4px;
      }
    }
    .item-box {
      flex: 2;
    }
  }
  ::v-deep .el-tabs__content {
    padding-bottom: 5px;
  }
  .arrowButn {
    display: block;
    margin: 0 auto;
    font-size: 28px;
    width: 30px;
    height: 30px;
    transform: rotate(90deg);
    cursor: pointer;
    color: #9dd3fb;
  }
}

::v-deep .el-cascader__tags {
  .el-tag {
    max-width: 62%;
  }
  .el-cascader__search-input {
    margin: 2px 0 2px 5px;
    min-width: 3%;
  }
}
</style>